let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j6NA8")).then(() => parcelRequire('4jyPp'));